module.exports = __webpack_public_path__ + "img/ic_plma.0654b3ad.svg";